<div class="page-header">
  <app-breadcrumb [project]="project" [easyCLA]="easyCLA" [childProject]="childProject" [committee]="committee"
    [extraCrumbs]="extraCrumbs"></app-breadcrumb>
  <app-configuration-status *ngIf="!hideProgress" [progressAndStatus]="progressAndStatus"
    [itxProgressAndStatus]="itxProgressAndStatus" [type]="type">
  </app-configuration-status>
</div>
